import styled from "styled-components";

export const PoliciesContainerStyle = styled.div`
  width: 80%;
  max-width: 960px;
  margin: 0 auto;
  color: ${(p) => p.theme.vars.palette.text.primary};
`;

export const styleForPolicies = `
  h1 {
    display: block;
    font-size: 2em;
    margin-top: 0.67em;
    margin-bottom: 0.67em;
    margin-left: 0;
    margin-right: 0;
    font-weight: bold;
    font-size: 36px;
  }
  h2 {
    display: block;
    font-size: 1.5em;
    margin-top: 0.83em;
    margin-bottom: 0.83em;
    margin-left: 0;
    margin-right: 0;
    font-weight: bold;
  }
  h3 {
    display: block;
    font-size: 1.17em;
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
    font-weight: bold;
  }
  p {
    display: block;
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
    line-height: 1.3;
  }
  ol li ol li {
    list-style-type: lower-alpha;
  }
  ol li ol li ol li {
    list-style-type: lower-roman;
  }
  ol, ul {
    list-style: disc outside none;
  }
  ol, ul, li {
    margin: 1em 0;
    padding-left: 20px;
    list-style-type: decimal;
  }
  .foot {
    margin-top: 30px;
    text-align: right;
  }
`;

export const GlobalPolicyStyle = styled.div`
  ${styleForPolicies}

  p, li {
    line-height: 1.5rem;
  }

  ul ul li {
    list-style-type: lower-alpha;
  }

  ul ul ul li {
    list-style-type: lower-roman;
  }
`;
